'use client';

import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { Box, LinearProgress, alpha } from '@mui/material';
import { themeColors } from '../theme/theme';

/**
 * Global page transition loader
 * Shows a loading bar at the top when navigating between pages
 */
export default function GlobalLoader() {
  // Only run on client side to avoid SSR issues with useSearchParams
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return <GlobalLoaderInner />;
}

function GlobalLoaderInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Start loading
    setLoading(true);

    // Simulate page load delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [pathname, searchParams]);

  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: 3,
      }}
    >
      <LinearProgress
        sx={{
          height: 3,
          bgcolor: alpha(themeColors.primaryColor, 0.2),
          '& .MuiLinearProgress-bar': {
            bgcolor: themeColors.primaryColor,
            boxShadow: `0 0 10px ${alpha(themeColors.primaryColor, 0.5)}`,
          },
        }}
      />
    </Box>
  );
}
